import { useTranslation } from "react-i18next";
import { AppLink } from "../lib/route-primitives";
import { ArrowRight } from "lucide-react";
import { SmsCampaignsPage as SharedSmsCampaignsPage } from "@wedding/sms-campaigns";
import { useAdminApi } from "../hooks/use-admin-api";
import { useWedding } from "../contexts/wedding-context";
import { paths } from "../lib/paths";

/**
 * Admin adapter — same UI, admin auth. Test-send is DISABLED: admins have no
 * "verified organizer phone number" concept (the worker's 403 on
 * /sms-campaigns/preview-send exists for the same reason), so the button stays
 * VISIBLE but disabled with an explanatory hint instead of silently vanishing.
 */
export function WeddingSmsPage() {
  const { wedding, slug } = useWedding();
  const api = useAdminApi();
  const { t, i18n } = useTranslation();
  return (
    <SharedSmsCampaignsPage
      slug={slug}
      wedding={wedding}
      api={api}
      locale={i18n.language}
      testSend={{ enabled: false, disabledReasonKey: "sms.testDisabledAdminHint" }}
      configLink={
        <AppLink
          to={paths.controlCenter}
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber-700 dark:text-amber-400 underline underline-offset-4 hover:no-underline cursor-pointer"
        >
          {t("sms.goToControlCenter")}
          <ArrowRight className="h-3.5 w-3.5" />
        </AppLink>
      }
    />
  );
}
